'use strict';

import React, { Component } from 'react'

import { v4 as uniqid } from 'uuid'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

import UpdateForm from '@/Form/UpdateForm'

import config from '@Config/Configuration/national_brand'

const { app } = window;

export default class NationalBrandPage extends Component
{
	state = { form_key: uniqid() };

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleValidation = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ form_key: uniqid() });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var output =
		(
			<Layout page_title="Modification d'une enseigne nationale"
				history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm config={ config }
									onValidate={ component.handleValidation }
									key={ state.form_key }
								/>

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}